import React from "react";
import cx from 'classnames';

import { Flex } from "@common/components/Flex";
import { CellProps, useController } from "./cell.controller";

import './cell.styles.scss';

export const Cell: React.FC<CellProps> = (props) => {
  const { className, column, currentColumnWidth, isFiltered } = props;
  const {
    resizingColumn,
    handleMouseDown,
    resizerOffset,
    handleContextMenu
  } = useController(props);

  // Determine sort icon class and number based on sortOrder and sortAsc from API
  const getSortIconInfo = () => {
    if (!column.sortOrder || column.sortOrder <= 0) {
      return null;
    }
    
    return {
      sortOrder: column.sortOrder,
      sortAsc: column.sortAsc || false,
      iconClass: column.sortAsc ? 'fa-sort-up' : 'fa-sort-down'
    };
  };

  const sortIconInfo = getSortIconInfo();

  // Create tooltip for sorted columns
  const getTooltip = () => {
    if (column.sortOrder && column.sortOrder > 0) {
      return `Sort Column Number ${column.sortOrder}`;
    }
    return (typeof column.header === 'string' || typeof column.header === 'number') ? column.header.toString() : undefined;
  };

  return (
    <Flex
      style={{
        minWidth: currentColumnWidth,
        width: currentColumnWidth,
        maxWidth: currentColumnWidth,
      }}
      className={cx(
          "SpreadsheetDetailsSpreadsheetResultTable__header__cell",
          className,
          { 
            'SpreadsheetDetailsSpreadsheetResultTable__header__cell--sorted': sortIconInfo,
            'SpreadsheetDetailsSpreadsheetResultTable__header__cell--has-filter': (isFiltered && !sortIconInfo),
            'SpreadsheetDetailsSpreadsheetResultTable__header__cell--has-sort': (!isFiltered && !!sortIconInfo),
            'SpreadsheetDetailsSpreadsheetResultTable__header__cell--has-both': (isFiltered && !!sortIconInfo),
          }
      )}
      onContextMenu={handleContextMenu}
    >
        <div title={column?.header?.toString()} className={cx(
          "SpreadsheetDetailsSpreadsheetResultTable__header__cell__content",
          {
            "SpreadsheetDetailsSpreadsheetResultTable__header__cell__content--with-icons": (isFiltered || sortIconInfo),
            "SpreadsheetDetailsSpreadsheetResultTable__header__cell__content--with-filter": (isFiltered && !sortIconInfo),
            "SpreadsheetDetailsSpreadsheetResultTable__header__cell__content--with-sort": (!isFiltered && !!sortIconInfo),
            "SpreadsheetDetailsSpreadsheetResultTable__header__cell__content--with-both": (isFiltered && !!sortIconInfo),
          }
        )}>
            {column.header}
        </div>

        {/* Right-side icons container: filter first, then sort */}
        {(isFiltered || sortIconInfo) && (
          <div className="SpreadsheetDetailsSpreadsheetResultTable__header__cell__icons">
            {isFiltered && (
              <span
                title="Filter applied"
                className="fa fa-filter SpreadsheetDetailsSpreadsheetResultTable__header__cell__filter-icon"
              />
            )}
            {sortIconInfo && (
              <div                   title={`sort column number ${sortIconInfo.sortOrder}`}
              className="SpreadsheetDetailsSpreadsheetResultTable__header__cell__sort-container">
                <span className="SpreadsheetDetailsSpreadsheetResultTable__header__cell__sort-number">
                  {sortIconInfo.sortOrder}
                </span>
                <span
                  className={cx(
                    'fa',
                    sortIconInfo.iconClass,
                    'SpreadsheetDetailsSpreadsheetResultTable__header__cell__sort-icon',
                    {
                      'SpreadsheetDetailsSpreadsheetResultTable__header__cell__sort-icon--down': sortIconInfo.iconClass === 'fa-sort-down'
                    }
                  )}
                />
              </div>
            )}
          </div>
        )}

      {column.enableResizing && (
        <span
          onMouseDown={handleMouseDown}
          title="Resize column"
          className={cx(
            'SpreadsheetDetailsSpreadsheetResultTable__header__cell__resize-icon',
            { 'SpreadsheetDetailsSpreadsheetResultTable__header__cell__resize-icon--active': resizingColumn },
          )}
          style={{
            right: resizingColumn ? -resizerOffset : 0,
          }}
        />
      )}
    </Flex>
  );
};